import type { AssetType } from "./asset-types";

/** Everything the field and picker say or accept that depends on which kind of
 *  file they hold. One table, so a new wording lands for both at once. */
export interface AssetKindCopy {
    noun: string;
    accept: string;
    dropPrompt: string;
    searchLabel: string;
    searchPlaceholder: string;
    renameTitle: string;
    notValid: string;
    notWhatItSays: string;
}

export const ASSET_KIND: Record<AssetType, AssetKindCopy> = {
    IMAGE: {
        noun: "image",
        accept: "image/*",
        dropPrompt: "Drop an image here, or",
        searchLabel: "Search images",
        searchPlaceholder: "Search images…",
        renameTitle: "Rename image",
        notValid: "That file couldn't be used — it isn't a valid image.",
        notWhatItSays: "That file couldn't be used — it isn't the kind of image its name says.",
    },
    FONT: {
        noun: "font",
        // Extensions rather than MIME types: browsers report fonts inconsistently,
        // and an accept list of font/* would hide perfectly good files.
        accept: ".ttf,.otf,.woff,.woff2",
        dropPrompt: "Drop a font file here, or",
        searchLabel: "Search fonts",
        searchPlaceholder: "Search fonts…",
        renameTitle: "Rename font",
        notValid: "That file couldn't be used — it isn't a valid font.",
        notWhatItSays: "That file couldn't be used — it isn't the kind of font its name says.",
    },
};
